import 'angular:locale/data:en-ZA';
import './apps/ecommerce-shop/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
